import {
	Card,
	CardAction,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../ui/card";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { Button } from "../ui/button";
import { getColorForScore } from "../../services/detect";
import type { PlagiarismSource } from "@shared/types";

interface PlagiarismDescriptionProps {
	sources: PlagiarismSource[];
}

export function PlagiarismSources({ sources }: PlagiarismDescriptionProps) {
	return (
		<div className="flex flex-col gap-2 px-3">
			{sources.map((source) => (
				<PlagiarismSourceItem
					key={source.url ?? source.title}
					source={source}
				/>
			))}
		</div>
	);
}

interface PlagiarismSourceItemProps {
	source: PlagiarismSource;
}

function getFoundText(source: PlagiarismSource) {
	const foundText = source.plagiarismFound[0];
	return foundText
		? foundText.sequence.slice(0, 125) +
				(foundText.sequence.length > 125 ? "..." : "")
		: null;
}

export function PlagiarismSourceItem({ source }: PlagiarismSourceItemProps) {
	const color = getColorForScore(source.score);
	const foundText = getFoundText(source);
	const scoreLabel = `${(source.score * 100).toFixed(0)}%`;
	const titleHasLetters = /[a-zA-Z]/.test(source.title || "");
	const sourceTitle =
		!titleHasLetters && source.source ? source.source : source.title;

	return (
		<Card className="bg-sidebar py-4">
			<CardHeader className="px-4">
				<div className="flex gap-2 items-center">
					<div
						style={{ backgroundColor: color }}
						className="rounded-sm px-2 py-1 text-xs text-white text-s"
					>
						{scoreLabel}
					</div>
					<CardTitle className="line-clamp-1">{sourceTitle}</CardTitle>
				</div>

				{source.url && (
					<CardDescription className="line-clamp-1">
						{source.url}
					</CardDescription>
				)}
				{source.url && (
					<CardAction>
						<Button
							variant="secondary"
							size="icon"
							className="size-5"
							asChild
							aria-label="Source URL"
						>
							<a href={source.url} target="_blank">
								<ArrowTopRightOnSquareIcon className="size-3" />
							</a>
						</Button>
					</CardAction>
				)}
			</CardHeader>

			<CardContent className="flex flex-col gap-3 px-4">
				{foundText ? <p className="text-xs">{foundText}</p> : null}
			</CardContent>
		</Card>
	);
}
